import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const InvestButton = (props) => {
  const navigate = useNavigate()
  console.log("props", props)
  const handleClick = (e) => {
    if (props.onClick) {
      e.preventDefault(); // Prevent navigation if `onClick` is provided
      props.onClick();
    }else {
      navigate(props.url)
    }
  };
  console.log("props?.disabled",props?.disabled)
  return (
    <button
      to={{ pathname: props.url, state: props.state }}  // Pass state dynamically from parent
      className={`btn invest_btn invest_btn_${props.color} ${props.className}`}
      onClick={handleClick} // Attach the click handler
      disabled={props?.disabled == "true" ? true : false}
    >
      {props.label}
    </button>
  );
};

export default InvestButton;
